import React, { useEffect, useState } from "react";
import { Descriptions, Divider, Steps, Typography, Tag, Button, Spin, Alert } from "antd";
import axios from "axios";
import { ENDPOINT } from "../../Services/ENDPOINT";
import TaskService from "../../Services/Manage/TaskService";

const { Title, Text } = Typography;

function ViewHistory({ task }) {
 const [history, setHistory] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");

  useEffect(() => {
    if (!task || !task.key) return;

    console.log(task.key);
    

    const fetchHistory = async () => {
      setLoading(true);
      setError(null);
      try {
        
        const getTimeLine = await TaskService.getTimeLine(task.key);
        console.log(getTimeLine);
        
        setHistory(getTimeLine.data || []);
        console.log(getTimeLine.data);
        
      } catch (err) {
        setError("Failed to load history data.");
      } finally {
        setLoading(false);
      }
    };

    fetchHistory();
  }, [task]);

  if (!task) return null;

  if (loading) return <Spin tip="Loading history..." />;
  if (error) return <Alert message={error} type="error" />;


const historySteps = history.length
  ? history.map((h) => ({
      title: h.status,

      date: h.completion_date || h.added_on || "",
      description: (
        <>
          {h.note && <div><strong>Note:</strong> {h.note}</div>}
          {h.comment && <div><strong>Comment:</strong> {h.comment}</div>}
          {h.on_hold_reason && <div><strong>Reason:</strong> {h.on_hold_reason}</div>}
          {h.completion_date && <div><strong>Completed On:</strong> {h.completion_date}</div>}
        </>
      ),
    }))
  : [
      {
        title: "Created",
        date: task.createdDate,
        description: task.createdNote || " ",
      },
    ];


  return (
    <div>
      <Descriptions title="Task Details"  column={1}>
        <Descriptions.Item label="Task">{task.task}</Descriptions.Item>
        <Descriptions.Item label="Description">{task.description}</Descriptions.Item>
        <Descriptions.Item label="Priority">{task.priority}</Descriptions.Item>
        <Descriptions.Item label="Status">
          <Tag color="blue">{task.status}</Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Employees">{task.employees?.join(", ")}</Descriptions.Item>
        <Descriptions.Item label="Due Date">{task.dueDate}</Descriptions.Item>
        <Descriptions.Item label="Urgency">{task.urgency}</Descriptions.Item>
      </Descriptions>

      <Divider />

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <Title level={4} style={{ margin: 0 }}>History</Title>
        <Button
          type="link"
          onClick={() => setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"))}
          style={{ margin: 0 }}
        >
          <span style={{ color: "#000", fontWeight: "bold" }}>Sort: </span>{sortOrder === "asc" ? "Oldest → Newest" : "Newest → Oldest"}
        </Button>
      </div>

      <Steps
        direction="vertical"
        size="small"
        current={-1}
        items={historySteps
          .sort((a, b) => {
            const dateA = new Date(a.date);
            const dateB = new Date(b.date);
            return sortOrder === "asc" ? dateA - dateB : dateB - dateA;
          })
          .map(({ title, date, description }) => ({
            title,
            description: (
              <>
                {date && <Text type="secondary" style={{ fontSize: 12 }}>{date}</Text>}
                {description}
              </>
            ),
          }))}
      />
    </div>
  );
}

export default ViewHistory;
